<template>
  <section style="line-height:28px;">
    <el-tag
      :key="index"
      v-for="(tag, index) in dynamicSessionTags"
      closable
      :disable-transitions="false"
      @close="handleClose(tag)"
    >
      {{ tag.startTime|datetime }}~{{ tag.endTime|datetime }}
    </el-tag>
    <section v-if="dynamicSessionTags.length < maxTagCount" style="overflow:hidden;">
      <el-date-picker
        class="input-new-tag"
        v-if="inputVisible"
        v-model="inputValue"
        type="datetimerange"
        format="yyyy-MM-dd HH:mm"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        ref="saveTagInput"
        size="mini"
        :placeholder="'最多'+maxTagCount+'场次'"
        @keyup.enter.native="handleInputConfirm"
        @blur="handleInputConfirm"
      >
      </el-date-picker>
      <el-button v-else class="button-new-tag" size="mini" @click="showInput">+场次</el-button>
    </section>
  </section>
</template>

<script>
import { datetime } from "../../util/filters";
export default {
  props: {
    tags: {
      type: Array,
      default: function(){ return [] },
    },
    maxTagCount: {
      type: Number,
      default: 5,
    },
  },
  name: "DynamicSessionTags",
  data() {
    return {
      dynamicSessionTags: [],
      inputVisible: false,
      inputValue: [],
    };
  },
  methods: {
    handleClose(tag) {
      this.dynamicSessionTags.splice(this.dynamicSessionTags.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue && inputValue.length==2) {
        this.dynamicSessionTags.push({
          startTime: datetime(inputValue[0]),
          endTime: datetime(inputValue[1])
        });
      }
      this.inputVisible = false;
      this.inputValue = [];
      this.$emit("dynamictagsInput", this.dynamicSessionTags);
    },
  },
  mounted() {
    if (this.tags && this.tags.length > 0) {
      this.dynamicSessionTags = this.tags;
    }
  },
};
</script>

<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.el-tag{padding: 0 5px;margin: 0 2px 2px 0px;}
.button-new-tag {
  margin-left: 10px !important;
  height: 28px;
  line-height: 28px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width:300px !important;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>